import { ButtonLinkFragment, NavigationFragment, Url } from '@custom/schema';
import { Frame } from '@custom/ui/routes/Frame';
import { graphql, useStaticQuery } from 'gatsby';
import React, { PropsWithChildren } from 'react';

function useFrameQuery() {
  return useStaticQuery<{
    mainNavigation: NavigationFragment;
    footerNavigation: NavigationFragment;
    legalNavigation: NavigationFragment;
  }>(graphql`
    query Frame {
      mainNavigation {
        items {
          ...NavigationItem
        }
      }
      footerNavigation {
        items {
          ...NavigationItem
        }
      }
      legalNavigation {
        items {
          ...NavigationItem
        }
      }
    }
  `);
}

const MetaMenuItems: Array<ButtonLinkFragment> = [
  {
    label: 'Contact us',
    target: '/contact' as Url,
    display: 'SECONDARY',
  },
  {
    label: 'Download',
    target: '/downloads' as Url,
    display: 'PRIMARY',
  },
];

export function Wrapper({ children }: PropsWithChildren) {
  const data = useFrameQuery();
  return (
    <Frame
      mainNavigation={{ items: data.mainNavigation.items }}
      footerNavigation={{ items: data.footerNavigation.items }}
      legalNavigation={{ items: data.legalNavigation.items }}
      metaNavigation={{ items: MetaMenuItems }}
    >
      {children}
    </Frame>
  );
}
